import * as React from 'react';
import { DevicePropsType } from '../../types';
const screenshotUrl = require( './screenshot.jpg' );

const MakeyourdayShowcasePhone : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <div><img src={ screenshotUrl } alt='MakeYourDay' /></div>
    );
  };

export default MakeyourdayShowcasePhone;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/MakeyourdayShowcasePhone/MakeyourdayShowcasePhone.tsx